import React, { useState } from 'react';
import { connect } from 'react-redux';

import { cloneDeep, isEmpty } from 'lodash';
import clsx from 'clsx';

import TextField from '@material-ui/core/TextField';

import BobConfirmButton from '../../../components/BobConfirmButton';
import BobCancelButton from '../../../components/BobCancelButton';
import BobModal from '../../../components/BobModal';

import * as ErpAgentActions from '../../../actions/erpAgentActions';

import * as classes from './RenameFsmAgentModal.module.css';

const RenameFsmAgentModal = ({
    activeNavCompany,
    integration,
    setRenameAgentModalOpen,
    updateErpAgent,
    ...props
}) => {

    const [isLoading, setIsLoading] = useState(false);
    const [newIntegrationName, setNewIntegrationName] = useState('');

    const handleNameChange = event => {
        setNewIntegrationName(event.target.value);
    };

    const handleUpdateIntegration = async () => {
        let updatedIntegration = cloneDeep(integration);

        updatedIntegration.name = newIntegrationName;
        setIsLoading(true);
        let isUpdated = await updateErpAgent(activeNavCompany.id, updatedIntegration.id, updatedIntegration);
        setIsLoading(false);

        if (isUpdated) setRenameAgentModalOpen(false);
    };

    return (
        <BobModal
            title={'Rename Agent'}
            hidebuttons={true}
            headerOverride={classes.HeaderOverride}
            isRemoveFooter={true}
            onClose={() => setRenameAgentModalOpen(false)}
        >
            <div className={classes.ModalBody}>
                <div className={classes.NamePanel}>
                    <div className={classes.Title}>
                        Integration Name
                    </div>
                    <div className={classes.IntegrationName}>
                        {integration.name}
                    </div>
                </div>
                <div className={classes.InputPanel}>
                    <TextField
                        key="New Integration Name"
                        id="standard-required"
                        label={<span>New Integration Name<span className={classes.Required}> *</span></span>}
                        placeholder="Enter"
                        value={newIntegrationName}
                        onChange={handleNameChange}
                        size="small"
                        inputProps={{
                            style: { fontSize: 14 }
                        }}
                        InputLabelProps={{
                            className: classes.NameLabel
                        }}
                        className={classes.NameInput}
                        variant="outlined"
                    />
                    <div className={classes.HelperText}>
                        <i className={clsx('fas fa-info-circle', classes.HelpIcon)} /> Please enter the new name for this integration.
                    </div>
                </div>
                <div className={classes.ButtonPanel}>
                    <BobCancelButton
                        disabled={isLoading}
                        onClick={() => setRenameAgentModalOpen(false)}
                        className={classes.CancelButton}
                        label={'Cancel'}
                    />
                    <BobConfirmButton
                        disabled={isEmpty(newIntegrationName) || isLoading}
                        onClick={() => handleUpdateIntegration()}
                        className={isEmpty(newIntegrationName) || isLoading ? classes.DisabledButtons : classes.Buttons}
                        label={'Rename'}
                        iconSize={15}
                        isLoading={isLoading}
                    />
                </div>
            </div>
        </BobModal>
    );
};

const mapStateToProps = state => ({
    activeNavCompany: state.bob.activeNavCompany,
});

const mapDispatchToProps = {
    ...ErpAgentActions
};

export default connect(mapStateToProps, mapDispatchToProps)(RenameFsmAgentModal);
